const pkg = [
  {
    id: 76,
    title: "Coconut Package",
    img: "/img/coconut-package.jpg",
    content: [
      "Coverage time: 6 hours",
      "Around 480 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 4287.87,
  },
  {
    id: 75,
    title: "Sand Package",
    img: "/img/sand-package.jpg",
    content: [
      "Coverage time: 5 hours",
      "Around 360 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 3294.99,
  },
  {
    id: 74,
    title: "Seashell Package",
    img: "/img/seashell-package.jpg",
    content: [
      "Coverage time: 4 hours",
      "Around 300 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 2767.79,
  },
  {
    id: 73,
    title: "Starfish Package",
    img: "/img/starfish-package.jpg",
    content: [
      "Coverage time: 3 hours",
      "Around 240 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 2187.87,
  },
  {
    id: 81,
    title: "Piña Package",
    img: "/img/piña-package.jpg",
    content: [
      "Coverage time: 2 hours",
      "Around 200 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 1739.75,
    excludedCountries: ['DO'],
  },
  {
    id: 72,
    title: "Island Package",
    img: "/img/island-package.jpg",
    content: [
      "Coverage time: 1 hour and 30 min",
      "Around 110 high resolution photos in JPG format with rights free for personal use in LINK.",
    ],
    usdPrice: 1318.00,
  },
  {
    id: 33,
    title: "Engagement Package",
    img: "/img/engagement-package.jpg",
    content: [
      "Ideal package for a rehearsal dinner or if you want to surprise your partner at the moment you pop the question.",
      "Coverage time: 1 hour",
      "Around 50 high resolution photos in JPG format with rights free for personal use in LINK.",
      "Not valid as a wedding package.",
      "*Please read the Terms and Conditions section.",
    ],
    usdPrice: 817.15,
  },
  {
    id: 999,
    title: "Live Test Package",
    img: "/img/coconut-package.jpg", // Using a placeholder image
    content: ["Test Item 1", "Test Item 2"],
    usdPrice: 1.00,
    test: true
  }
];

// Verify if test package is enabled
const enableTest = import.meta.env.VITE_ENABLE_TEST_PACKAGE === 'true';
const finalPkg = enableTest ? pkg.filter(p => p.id === 999) : pkg.filter(p => p.id !== 999);

export { finalPkg as pkg };
